/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BidIncrementsDto } from '../models/bid-increments-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedBidIncrementService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBidIncrements
   */
  static readonly GetBidIncrementsPath = '/api/bid-increments';

  /**
   * Gets all bid increments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidIncrements()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidIncrements$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BidIncrementsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidIncrementService.GetBidIncrementsPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BidIncrementsDto>>;
      })
    );
  }

  /**
   * Gets all bid increments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidIncrements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidIncrements(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Array<BidIncrementsDto>> {

    return this.getBidIncrements$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BidIncrementsDto>>) => r.body as Array<BidIncrementsDto>)
    );
  }

}
